exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".wrap[data-v-5e066386]{display:flex;justify-content:center;align-items:center;width:100%;height:100%}", ""]);

// exports
